import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import ban from "../../assets/images/together/b1.png";
import ban1 from "../../assets/images/together/b2.png";
import ban2 from "../../assets/images/together/b3.png";
import ban3 from "../../assets/images/together/b5.png";
import tran from "../../assets/images/together/logo2.png";
import love from "../../assets/images/together/love.png";
import love1 from "../../assets/images/together/love1.png";
import love2 from "../../assets/images/together/love2.png";
import love3 from "../../assets/images/together/love3.png";
import baby from "../../assets/images/together/baby.png";
import baby1 from "../../assets/images/together/baby1.png";
import baby2 from "../../assets/images/together/baby2.png";
import baby3 from "../../assets/images/together/baby3.png";
import out from "../../assets/images/together/out.png";
import out1 from "../../assets/images/together/out1.png";
import out2 from "../../assets/images/together/out2.png";
import slider from "../../assets/images/together/sl.png";
import slider1 from "../../assets/images/together/sl2.png";
import cus from "../../assets/images/together/te.png";
import cus1 from "../../assets/images/together/te1.png";
import cus2 from "../../assets/images/together/te2.png";
import cus3 from "../../assets/images/together/te3.png";

export default function HomePage() {
    return (
        <React.Fragment>
            {/*                     banner slider                 */}

            <div class="carousel w-full">
                <div id="item1" class="carousel-item w-full">
                    <img src={slider1} class="w-full" />
                </div>
                <div id="item2" class="carousel-item w-full">
                    <img src={slider} class="w-full" />
                </div>
            </div>
            <div class="flex justify-center w-full py-2 gap-2">
                <a href="#item1" class="btn btn-xs btn-circle">1</a>
                <a href="#item2" class="btn btn-xs btn-circle">2</a>

            </div>
            {/*                     banner slider                 */}

            <div class="w-full pt-10">
                <div div className='container w-4/5 text-center'>
                    <h1 className='font-semibold text:2xl lg:text-3xl xl:text-3xl 2xl:text-3xl'> Together Wedding Studio </h1>
                </div>
                <div className='container w-4/5 text-center'>
                    <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-10'>"We are a photo studio & bridal house providing all kinds of photo shooting service especially pre wedding photo . And also all kinds of makeup services and dress, gown rental & sales .
                        You are welcome to visit us or call us for any inquires ."</p>
                </div>
                <div className='container w-4/5 text-center'>
                    <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-10'>"We are the new branch in Yangon from Together Wedding Studio Mandalay, we are welcome all to visit us in Yangon and we will create more surprises to you all."</p>
                </div>

            </div>

            {/*                     banner photo                  */}

            <div className="w-fix">
                <div className='container w-4/5 text-center pt-20'>
                    <h1 className='font-semibold text:2xl lg:text-4xl xl:text-4xl 2xl:text-4xl'> Gallery</h1>
                    <p className='pt-5'> "C r e a t e B y T o g e t h e r W e d d i n g S t u d i o"</p>
                </div>
                <div className="container grid grid-cols-2 xl:grid-cols-2 gap-2 pt-10 w-5/6 h-4/6">

                    <div className=" w-full h-fit ">
                        <img src={ban1} ></img>

                    </div>
                    <div className="w-full h-fit ">
                        <img src={ban} ></img>

                    </div>
                    <div className="w-full h-fit">
                        <img src={ban2} ></img>

                    </div>
                    <div className="w-full h-fit">
                        <img src={ban3} ></img>

                    </div>

                </div>
                <div className='pt-10 text-center'>
                    <button className="btn btn-outline btn-xs lg:btn-sm xl:btn-md btn-outline "><a href="#"> View More Gallery  </a></button>
                </div>
            </div>
            <div className='pt-5 py-1'>
                <hr className='color-[#0000]'></hr>
            </div>

            {/*                 end of banner photo               */}

            {/*                   slider section                  */}

            <div className="w-fix pt-20">
                <div className='container w-4/5 text-center'>
                    <h1 className='font-semibold text:2xl lg:text-4xl xl:text-4xl 2xl:text-4xl'> Featured  Wedding </h1>
                </div>
                <div className='container text-center'>
                    <p className='px-1 lg:px-40 xl:px-40 pt-10 pb-10'>"We believe that images are the building block of an unfolding story. We want to be there with you, on your special day, to capture every moment, every look, every kiss, and give you memories that will last a lifetime."</p>
                </div>
                <div class="w-full bg-cover pt-10 bg-toge_ban xl:bg-toge_ban lg:bg-toge_ban">
                    <div className="py-10 lg:py-40 xl:py-57 md:py-52 pb-10 text-center">

                    </div>
                </div>

                <div class="w-full lg:-mt-28 xl:-mt-28 py-10 lg:py-20 xl:py-30 md:py-52">
                    <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 place-items-center">

                        <div className="lg:pl-2 xl:pl-2 pb-5 focus-visible">
                            <img src={love}></img>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 pb-5">
                            <img src={love2} ></img>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 pb-5 focus-visible">
                            <img src={love3} ></img>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 pb-5 focus-visible">
                            <img src={love1} ></img>
                        </div>
                    </div>
                    <div className='container w-4/5 text-center'>
                        <p className='px-1 lg:px-40 xl:px-40 pt-2'>"We are the new branch in Yangon from Together Wedding Studio Mandalay, we are welcome all to visit us in Yangon and we will create more surprises to you all ."</p>
                    </div>

                </div>
                <div className=' py-1'>
                    <hr className='color-[#0000]'></hr>
                </div>
                {/*                 end of slider dection            */}

                {/*                 baby section                     */}
                <div class="w-full pt-10">
                    <div div className='container w-4/5 text-center'>
                        <h1 className='font-semibold text-2xl'> First Trial Card </h1>
                    </div>
                    <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 pt-5 place-items-center">

                        <div className="lg:pl-2 xl:pl-2 pb-5 focus-visible">
                            <img src={baby} ></img>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 pb-5">
                            <img src={baby2}></img>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 pb-5 focus-visible">
                            <img src={baby1} ></img>
                        </div>
                        <div className="lg:pl-2 xl:pl-2 pb-5 focus-visible">
                            <img src={baby3}></img>
                        </div>

                    </div>
                    <div className='container w-4/6 text-center'>
                        <p className='px-1 lg:px-40 xl:px-40 pt-2'>"ရင်သွေးရတနာ Baby လေးတွေရဲ့မွေးကင်းစမှအစ ကြီးပြင်းလာတဲ့အချိန်အတွင်း ချစ်စရာအခိုက်တန့်လေးတွေကို အမြဲအမှတ်ရနေစေဖို့"</p>
                    </div>
                </div>

            </div>

            {/*              end of baby section               */}

            {/*             hero product                       */}

            <div class="carousel pt-10 w-full">
                <div id="slide1" class="carousel-item relative w-full">
                    <div class="hero min-h-screen">
                        <div class="hero-content flex-col lg:flex-row">
                            <img src={cus} class=" rounded-lg shadow-2xl" />
                            <div>
                                <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">Customer Feedback</h1>
                                <p class="py-6 pt-20"> “ 𝐁𝐞𝐚𝐮𝐭𝐢𝐟𝐮𝐥 𝐢𝐧 𝐰𝐡𝐢𝐭𝐞 🤍
                                    ကိုယ်ကရိုးရှင်းတာလေးတွေကြိုက်တာမို့
                                    ၀တ်စုံအဖြူ‌တွေချည်းကိုမှ
                                    ရိုးရိုးလေးတွေပဲ ရွေးခဲ့တာတောင်
                                    ကြည့်လို့မ၀တဲ့ ပုံလှလှလေးတွေဖစ်အောင်
                                    ဖန်တီးပံ့ပိုးပေးကြတဲ့
                                    Together Wedding Studio - Yangon ကို
                                    ကျေးဇူးအထူးပါနော် 😍
                                    ထပ်ရိုက်ဖို့လဲ ကြံစည်နေပါပြီနော် 😋❤️
                                    #togetherweddingstudio ”</p>
                                <p className='lg:pt-20 xl:pt-20 font-semibold'> Aung Ye Htet Paing & Hnin </p>
                            </div>
                        </div>
                    </div>
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide4" >❮</a>
                        <a href="#slide2" >❯</a>
                    </div>
                </div>
                <div id="slide2" class="carousel-item relative w-full">
                    <div class="hero min-h-screen">
                        <div class="hero-content flex-col lg:flex-row">
                            <img src={cus1} class=" rounded-lg shadow-2xl" />
                            <div>
                            <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">Customer Feedback</h1>
                                <p class="py-6 pt-20">“ My Belated Prewedding Photo
                                    Let me save my memories
                                    I apologize to you all for this uploads
                                    Together Wedding Studio - Yangon
                                    #MUA_LilianHwa
                                    #photographer_JeffHwa ”</p>
                                <p className='lg:pt-40 xl:pt-40 font-semibold'> Ye Win Hlaing & May Saw </p>
                            </div>
                        </div>
                    </div>
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide1" >❮</a>
                        <a href="#slide3" >❯</a>
                    </div>
                </div>
                <div id="slide3" class="carousel-item relative w-full">
                    <div class="hero min-h-screen">
                        <div class="hero-content flex-col lg:flex-row">
                            <img src={cus2} class=" rounded-lg shadow-2xl" />
                            <div>
                            <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">Customer Feedback</h1>
                                <p class="py-6 pt-20">“Happy blessed birthday Darling ❤️”
                                    #မနက်ဖြန်မှာဘာဖြစ်မလည်းမသိပေမဲ့
                                    #ရှိနေတဲ့ဒီအချိန်လေးမှာတော့မွေးနေ့ကိုနုတ်ဆက်ပါရစေ
                                    Darling 😘 I ❤️ you 😘 Joseph San Min
                                    #37thYear! Together Wedding Studio - Yangon Thanks!</p>
                                <p className='lg:pt-40 xl:pt-40 font-semibold'> Deborah Aye Thanda </p>
                            </div>
                        </div>
                    </div>
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide2" >❮</a>
                        <a href="#slide4" >❯</a>
                    </div>
                </div>
                <div id="slide4" class="carousel-item relative w-full">
                    <div class="hero min-h-screen">
                        <div class="hero-content flex-col lg:flex-row">
                            <img src={cus3} class=" rounded-lg shadow-2xl" />
                            <div>
                            <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">Customer Feedback</h1>
                                <p class="py-6 pt-20">“ Thank You for your part in my Journey, Amoe and Aparr.
                                    Thank You for supporting me in every way from the day I was born and til now.
                                    Thank You for being Role models I look up to.
                                    Thank You being Best Parents for me.
                                    Even I can’t be good enough like you guys,
                                    I promise I will try hard from now on and make you proud.
                                    My Education journey from KG to M.B.B.S won’t be completed without your support. ❤️
                                    Love you heaps. 💞💕”</p>
                                <p className='lg:pt-40 xl:pt-40 font-semibold'> Naw Lar Ku Paw </p>
                            </div>
                        </div>
                    </div>
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide3" >❮</a>
                        <a href="#slide1" >❯</a>
                    </div>
                </div>
            </div>

            {/*             end of hero product                  */}

            {/*                 outdoor section                     */}

            {/*              end of outdoor section               */}


        </React.Fragment>
    )
}
